import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_GET_INVESTMENT_TRANSACTIONS } from "../../../config/api";

export const getportfolioTransactions = createAsyncThunk(
  "portfolioTransactions/GET",
  async ({ id, cb, failed }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: API_GET_INVESTMENT_TRANSACTIONS + id,
      });

      cb(data);
      return data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      // mixpanel.track("Error", {

      failed();
      toast.error(msg);
      throw error;
    }
  }
);
